import React from "react";
import "./WaterFab.css"; // Assuming you have a CSS file for styling

const WaterFab = () => {
  return (
    <div>
      <section className="common-page-hero">
        <img
          src="assets/img/service/mw7.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p
                className="ak-section-subtitle animation-title"
                style={{ perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Courses".split("").map((char, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>
              </p>
              <br />
              <p
                className="mini-title1"
                style={{
                  backgroundColor: "rgb(232, 119, 34)",
                  color: "white",
                  padding: "5px 10px",
                  fontWeight: "bold",
                  display: "inline-block",
                  borderRadius: "5px",
                }}
              >
                SEMANTIC Skills Junction
              </p>
              <br />
              <h2
                className="ak-section-title animation-title"
                style={{ fontSize: "45px", perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"SEMANTIC Skills Junction: Bridging"
                    .split(" ")
                    .map((word, idx1) => (
                      <span
                        key={idx1}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        {word.split("").map((char, idx2) => (
                          <div
                            key={idx2}
                            style={{
                              position: "relative",
                              display: "inline-block",
                              transform: "translate(0px, 0px)",
                              opacity: 1,
                            }}
                          >
                            {char}
                          </div>
                        ))}
                        &nbsp;
                      </span>
                    ))}
                </div>
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Talent and Technology".split(" ").map((word, idx1) => (
                    <span
                      key={idx1}
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      {word.split("").map((char, idx2) => (
                        <div
                          key={idx2}
                          style={{
                            position: "relative",
                            display: "inline-block",
                            transform: "translate(0px, 0px)",
                            opacity: 1,
                          }}
                        >
                          {char}
                        </div>
                      ))}
                      &nbsp;
                    </span>
                  ))}
                </div>
              </h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Course
            </p>
          </div>
          <a href="tel:+917619617023" className="phone-number">
            (+91) 7619617023
          </a>
        </div>
      </section>

      <div class="course-container">
        <div class="header">
          <h1 class="title">Wafer Fabrication Courses</h1>
          <div class="program-info">
            <h2 class="info-title">Program Information</h2>
            <ul class="program-info-list">
              <li class="program-info-item">
                Short Term Programmes (0.5 day to 1 day)
              </li>
              <li class="program-info-item">
                Industry Case Studies and Videos included to enhance
                participants comprehension
              </li>
              <li class="program-info-item">
                Can be offered onsite if required
              </li>
            </ul>
          </div>
        </div>
        <div class="courses-grid">
          <div class="course-card">
            <h3 class="course-title">Defects and Wafer Inspection</h3>
            <p class="course-description">
              Understanding wafer defects and inspection techniques
            </p>
            <span class="category-tag">Quality Control</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Factory overview - Modules, Equipment, Manufacturing
            </h3>
            <p class="course-description">
              Comprehensive overview of wafer fabrication facilities
            </p>
            <span class="category-tag">Manufacturing</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Oxidation, Wet Clean - Process, Equipment, Metrology
            </h3>
            <p class="course-description">
              Fundamentals of oxidation and cleaning processes
            </p>
            <span class="category-tag">Module Engineering</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Diffusion, RTP - Process, Equipment, Metrology
            </h3>
            <p class="course-description">
              Thermal processing and rapid thermal annealing
            </p>
            <span class="category-tag">Module Engineering</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Ion Implant - Process, Equipment, Metrology
            </h3>
            <p class="course-description">
              Ion implantation techniques and equipment
            </p>
            <span class="category-tag">Module Engineering</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Photolithography - Process, Equipment, Metrology
            </h3>
            <p class="course-description">
              Basic photolithography processes and tools
            </p>
            <span class="category-tag">Module Engineering</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Advanced Photolithography - Resolution Enhancement, Multiple
              Patterning, EUV
            </h3>
            <p class="course-description">
              Cutting-edge lithography techniques
            </p>
            <span class="category-tag">Advanced Lithography</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Etch - Process, Equipment, Metrology</h3>
            <p class="course-description">Etching processes and equipment</p>
            <span class="category-tag">Module Engineering</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Metallization - Process, Equipment, Metrology
            </h3>
            <p class="course-description">Metal deposition and processing</p>
            <span class="category-tag">Module Engineering</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              CVD [Chemical Vapor Deposition] - Process, Equipment, Metrology
            </h3>
            <p class="course-description">
              Chemical vapor deposition techniques
            </p>
            <span class="category-tag">Module Engineering</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              CMP [Chemical Mechanical Planarization] - Process, Equipment,
              Metrology
            </h3>
            <p class="course-description">Surface planarization processes</p>
            <span class="category-tag">Module Engineering</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Atomic Layer Processing - ALD, ALE</h3>
            <p class="course-description">
              Atomic layer deposition and etching
            </p>
            <span class="category-tag">Advanced Process</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Failure Analysis (FA) Techniques</h3>
            <p class="course-description">
              Methods for analyzing process failures
            </p>
            <span class="category-tag">Trouble Shooting</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaterFab;
